import type { CityConfig } from "../city-template/types";

export const yarmouthConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Cumberland County Clerk", href: "https://www.cumberlandcounty.org/", description: "Cumberland County Clerk — marriage license issuance" },
    { label: "Divorce Records — Cumberland County Clerk", href: "https://www.cumberlandcounty.org/", description: "Cumberland County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Yarmouth",
  state: "Maine",
  stateAbbr: "ME",
  slug: "yarmouth",
  route: "/cities/yarmouth",
  title: "Emergency Passport Yarmouth, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Yarmouth, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Yarmouth, Freeport, Cumberland, Falmouth, and Casco Bay area travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Yarmouth, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Yarmouth and Casco Bay travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Yarmouth%20Maine%20charming%20coastal%20village%20with%20historic%20architecture%2C%20Main%20Street%20lined%20with%20white%20clapboard%20houses%20and%20New%20England%20church%20steeple%2C%20Casco%20Bay%20visible%20in%20background%2C%20summer%20afternoon%20light%2C%20quaint%20harbor%20town%20atmosphere%2C%20professional%20photography%2C%20no%20people%20or%20visible%20text%2C%20soft%20blue%20sky%20and%20green%20coastal%20landscape&width=1800&height=700&seq=yarmouth-me-hero-001&orientation=landscape",
  heroImageAlt: "Yarmouth Maine charming coastal village with historic homes and Casco Bay",
  geoPosition: "43.8006;-70.1870",
  geoPlacename: "Yarmouth, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 120 miles (2 hours) from Yarmouth, ME",
  },
  nearbyCitiesZips: [
    { name: "Yarmouth", zips: "04096" },
    { name: "Freeport", zips: "04032" },
    { name: "Cumberland", zips: "04021" },
    { name: "Falmouth", zips: "04105" },
    { name: "North Yarmouth", zips: "04097" },
    { name: "Pownal", zips: "04069" },
    { name: "Gray", zips: "04039" },
    { name: "New Gloucester", zips: "04260" },
    { name: "Chebeague Island", zips: "04017" },
    { name: "Cousins Island", zips: "04096" },
    { name: "Littlejohn Island", zips: "04096" },
    { name: "Casco Bay Islands", zips: "04017" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Yarmouth departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Freeport", route: "/cities/freeport" },
    { name: "Emergency passport help in Portland", route: "/cities/portland-me" },
    { name: "Urgent passport services in Falmouth", route: "/cities/falmouth" },
    { name: "Same-day passport help in Cumberland", route: "/cities/cumberland-me" },
    { name: "Expedited passport services in Brunswick", route: "/cities/brunswick" },
    { name: "Passport courier services in Scarborough", route: "/cities/scarborough" },
    { name: "Rush passport help in South Portland", route: "/cities/south-portland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Yarmouth, Maine remotely via secure courier. We do not have a walk-in office in Yarmouth — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Yarmouth travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving Casco Bay and the surrounding coastal areas",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Yarmouth and the Casco Bay region. From historic Main Street to the islands of Cousins Island and Littlejohn Island — we help Yarmouth travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Yarmouth neighborhoods and nearby towns including Freeport, Cumberland, Falmouth, North Yarmouth, Pownal, Gray, and New Gloucester. If you are in the Casco Bay area, we have you covered.",
  howItWorksIntro: "Most Yarmouth travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Yarmouth is a charming coastal town just minutes from Portland, but passport acceptance facilities still have strict requirements. Here are the most common mistakes we see from Yarmouth-area travelers.",
  testimonialsIntro: "Yarmouth travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Yarmouth? Here are the most common ones we hear from Casco Bay travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Yarmouth international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Yarmouth, ME",
      rating: 5,
      text: "We were planning a cruise to the Caribbean and my passport had expired. Fast Passport Center got my renewal done in 3 days. I shipped from the Freeport UPS Store and it was seamless. Highly recommend for Casco Bay families.",
      service: "Passport Renewal",
    },
    {
      name: "Michael R.",
      location: "Cumberland, ME",
      rating: 5,
      text: "Business trip to Toronto came up last minute and my passport was nowhere to be found. Fast Passport Center delivered a replacement in 2 days. Their courier service is a game-changer for southern Maine.",
      service: "Lost Passport",
    },
    {
      name: "Sarah K.",
      location: "Falmouth, ME",
      rating: 5,
      text: "Needed emergency passports for our family of four after a last-minute opportunity to visit family in Ireland. Fast Passport Center handled everything, and we got all four passports in under a week. Simply amazing.",
      service: "Emergency Passport",
    },
    {
      name: "Thomas B.",
      location: "North Yarmouth, ME",
      rating: 5,
      text: "Child passport for my son's first international trip. Fast Passport Center helped us navigate both parents' consent requirements and got the passport in 5 days. We were so grateful for the personal guidance.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "yarmouth-1",
      name: "Yarmouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Forest Falls Dr",
      city: "Yarmouth",
      state: "ME",
      zip: "04096",
      phone: "(207) 846-4761",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Yarmouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Limited passport acceptance hours. Call ahead to confirm availability and book appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "yarmouth-2",
      name: "Freeport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9 Coastal Rd",
      city: "Freeport",
      state: "ME",
      zip: "04032",
      phone: "(207) 865-4821",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles from Yarmouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Yarmouth and Freeport residents. Appointment slots fill quickly.",
      icon: "ri-mail-line",
    },
    {
      id: "yarmouth-3",
      name: "Falmouth Town Office",
      type: "Town Office Passport Acceptance",
      address: "271 Falmouth Rd",
      city: "Falmouth",
      state: "ME",
      zip: "04105",
      phone: "(207) 781-5253",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "8 miles from Yarmouth",
      website: "https://www.falmouthme.org/",
      websiteLabel: "Falmouth Town Office",
      notes: "Convenient for Falmouth, Cumberland, and Yarmouth residents. Appointment preferred.",
      icon: "ri-government-line",
    },
    {
      id: "yarmouth-4",
      name: "Cumberland Town Office",
      type: "Town Office Passport Acceptance",
      address: "290 Tuttle Rd",
      city: "Cumberland",
      state: "ME",
      zip: "04021",
      phone: "(207) 829-2205",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles from Yarmouth",
      website: "https://www.cumberlandmaine.com/",
      websiteLabel: "Cumberland Town Office",
      notes: "Good option for Cumberland and North Yarmouth residents. Call ahead to schedule.",
      icon: "ri-government-line",
    },
    {
      id: "yarmouth-5",
      name: "Gray Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7 Shaker Rd",
      city: "Gray",
      state: "ME",
      zip: "04039",
      phone: "(207) 657-4921",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles from Yarmouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Rural option for Gray and New Gloucester residents.",
      icon: "ri-mail-line",
    },
    {
      id: "yarmouth-6",
      name: "Portland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 Forest Ave",
      city: "Portland",
      state: "ME",
      zip: "04101",
      phone: "(207) 871-8381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles from Yarmouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility with the most appointment availability. Best backup option.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Yarmouth acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Yarmouth applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Yarmouth families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Yarmouth travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Yarmouth or Freeport." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Yarmouth address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Yarmouth, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Yarmouth in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Yarmouth travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Yarmouth, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Yarmouth residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Yarmouth, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Yarmouth with no office visit required. We serve all Yarmouth neighborhoods and the Casco Bay area. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How close is Yarmouth to the Boston Passport Agency?",
      a: "Yarmouth is approximately 120 miles from the Boston Passport Agency — about a 2-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities, saving you time and stress.",
    },
    {
      q: "What acceptance facilities are near Yarmouth, Maine?",
      a: "Options near Yarmouth include the Yarmouth Post Office (04096), Freeport Post Office (04032), Falmouth Town Office (04105), and Cumberland Town Office (04021). The Portland Main Post Office (04101) is just 15 miles away with the most appointment slots. We help you find the most convenient location.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "What if I live on Cousins Island or Littlejohn Island?",
      a: "We serve all Yarmouth residents including those on Cousins Island, Littlejohn Island, and other Casco Bay areas. Our overnight shipping labels work from any UPS location, and we can also arrange pickup service. Your island location doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Yarmouth?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and needs.",
    },
    {
      q: "What documents do I need for a first-time passport in Yarmouth?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Yarmouth?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Yarmouth families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "Is there a UPS Store near Yarmouth for shipping documents?",
      a: "Yes, there's a UPS Store in Freeport at 30 Main St, about 6 miles from Yarmouth. We provide a prepaid overnight label — just drop your package at any UPS location or schedule a pickup. The Portland UPS Store on Forest Ave is another nearby option.",
    },
    {
      q: "Can I get passport photos taken in Yarmouth?",
      a: "The CVS Pharmacy on Main Street in Yarmouth offers passport photo services. The Walgreens on US Route 1 in Freeport and the Rite Aid on Main Street in Falmouth also take passport photos. We recommend reviewing photos with us before your acceptance clerk visit.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Yarmouth", address: "464 US Route 1, Yarmouth, ME 04096", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Freeport", address: "3 US Route 1, Freeport, ME 04032", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Rite Aid — Falmouth", address: "251 US Route 1, Falmouth, ME 04105", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Portland", address: "700 Forest Ave, Portland, ME 04103", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Portland", address: "700 Forest Ave, Portland, ME 04103", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Freeport", address: "30 Main St, Freeport, ME 04032", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart Photo Center — Portland", address: "700 Warren Ave, Portland, ME 04103", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Cumberland", address: "136 Main St, Cumberland, ME 04021", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Portland",
      address: "36 Pine St, Portland, ME 04102",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. Online appointment booking available. 15 miles from Yarmouth.",
      featured: true,
    },
    {
      name: "BMV — Yarmouth",
      address: "15 Forest Falls Dr, Yarmouth, ME 04096",
      hours: "Mon–Fri: 9AM–4PM",
      note: "Limited services only. Full transactions require Portland location.",
      featured: false,
    },
    {
      name: "BMV — Brunswick",
      address: "18 Pleasant St, Brunswick, ME 04011",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Second nearest full-service BMV. 20 miles from Yarmouth.",
      featured: false,
    },
    {
      name: "BMV — Scarborough",
      address: "600 US Route 1, Scarborough, ME 04074",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Cumberland County option. About 20 miles from Yarmouth.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "15 miles from Yarmouth (20 min)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with direct flights to major U.S. hubs, Florida, and Canada. The closest and most convenient international departure point for Yarmouth travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "120 miles from Yarmouth (2 hours)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport. Good alternative for northern Maine connections.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "120 miles from Yarmouth (2 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many southern Maine travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};